<template>
	<div class="allchain">
		<leftnav class="fl" :mkcode="curWebsite.type == 6 ? 'L' : 'B'"
			:itemcode="curWebsite.type == 6 ? yj_itemcode : 'B-QGTP'" docutitle="全部产业图谱"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">研究报告</span>
						<!-- <div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> -->
					</div>
					<div class="opport-screen-list1">
						<dl class="opport-screen bdbe">
							<dt class="fl">一级行业</dt>
							<dd class="fl">
								<span :class="industryValue == 0 ? 'a-screen current' : 'a-screen'"
									@click="chooseIndutry({paraValue:0,paraName:'全部'},1)">全部</span>
								<span :class="industryValue == list.paraValue ? 'a-screen current' : 'a-screen'"
									@click="chooseIndutry(list, 1)" :key="i" v-for="(list, i) in industryList">{{
										list.paraName }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="industryList2.length > 0">
							<dt class="fl">二级行业</dt>
							<dd class="fl">
								<span :class="industryValue2 == list.paraValue ? 'a-screen current' : 'a-screen'"
									@click="chooseIndutry(list, 2)" :key="i" v-for="(list, i) in industryList2">{{
										list.paraName }}</span>
							</dd>
						</dl>
					</div>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" >产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					</div>
					<div class="">
						<ul class="margin-x-auto widthPC-95 oh">
							<li class="report_li" v-for="(list, i) in reportList" :key="i" @click="routerblank('/reportDetail?id='+list.id)">
								<div class="img-box"><img :src="list.image" /></div>
								<div>
									<h4 class="title">{{ list.title }}</h4>
									<p class="indu_date smfont">最新修订：{{ list.reviseDate }} </p>
									<p class="indu_date smfont">报告属性：共{{ list.wordCount }} 万字、{{ list.chartCount }} 个图表
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'allchain',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "全国图谱-更多产业图谱",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			yj_itemcode: "",
			reportList: [],
			industryList: [],
			industryList2: [],
			industryValue: 0,
			industryValue2: 0,
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 

		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
		this.getparameterList();
	},
	mounted() { },
	methods: {
		chooseIndutry(list,step) {
			if(step == 1){
				if(list.paraValue == 0){
					this.industryValue = 0;
					this.industryValue2 =0;
					this.industryList2=[];
					console.log(list);
				}else {
					this.industryValue = list.paraValue;
					this.industryList2 = list.children;
					this.industryValue2 = '';
				}
			}else if(step == 2){
				this.industryValue2 = list.paraValue;
			}
			this.getList();
		},
		getparameterList(value) {
			var _this = this;
			var ajaxurl = this.$api.free.report.industryList();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('行业参数', res);
					_this.industryList = res.data.list;
					// if(_this.industryList.length>0){
					// 	_this.chooseIndutry(_this.industryList[0], 1);
					// }
				_this.getList();

				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getList(pages) {
			var _this = this;
			this.page = pages ? pages : 1;
			this.bus.$emit('loading', true);
			var ajaxurl = this.$api.free.report.list() + '?page=' + this.page + '&industry1=' + this.industryValue + '&industry2=' + this.industryValue2;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					console.log('报告列表', res, ajaxurl);
					_this.reportList = res.data.list;
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			this.getList(page);
		},

	},
}
</script>

<style lang="scss">
.report_li {
	width: calc(32% - 60px);
	border: 1px solid rgb(231, 231, 231);
	border-radius: 4px;
	box-shadow: 2px 3px 5px 1px rgb(231, 231, 231);
	height: 130px;
	padding: 20px 10px;
	float: left;
	margin: 20px;
	&:hover{
		scale: 1.05;
		cursor: pointer;
		transition: all 0.3s;
		.title{
			color: #5E83CC;
		}
	}
	.img-box {
		width: 86px;
		height: 126px;
		float: left;
		margin-right: 10px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.title {
		padding-top: 5px;
		height: 48px;
		line-height: 24px;
		text-overflow: ellipsis;
		overflow: hidden;
		font-size: 16px;
		padding-bottom: 5px;
	}

	.smfont {
		color: #707070;
		font-size: 14px;
	}
}
</style>